import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Price } from '@thd-olt-component-react/price';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { LoadingButton } from '@one-thd/sui-atomic-components';

const PriceMessage = ({
  itemId,
  listId,
  loading,
  message,
  onAddToListClick,
  pricing,
  storeId
}) => {
  const { channel } = useContext(ExperienceContext);

  return (
    <div className="sui-m-0 sui-w-full sui-min-w-64">
      <div className="sui-flex sui-flex-row sui-leading-none sui-items-center sui-gap-2 sui-mb-2">
        <div className="sui-text-lg sui-font-w-bold sui-leading-7">
          {message.priceMessage}
        </div>
        <Price
          channel={channel}
          itemId={itemId}
          large
          product={pricing}
          storeId={storeId}
        />
      </div>
      {listId && (
        <div className="sui-w-64">
          <LoadingButton
            onClick={onAddToListClick}
            disabled={message.isDisabled}
            loading={loading}
            variant="secondary"
          >
            {message.atlMessage}
          </LoadingButton>
        </div>
      )}
    </div>
  );
};

PriceMessage.propTypes = {
  itemId: PropTypes.string.isRequired,
  listId: PropTypes.string, // Optional - when undefined, add-to-list button is not rendered
  message: PropTypes.shape({
    priceMessage: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    atlMessage: PropTypes.string
  }).isRequired,
  onAddToListClick: PropTypes.func.isRequired,
  pricing: PropTypes.shape({
    pricing: PropTypes.shape({
      value: PropTypes.number,
      original: PropTypes.number,
      message: PropTypes.string
    })
  }).isRequired,
  loading: PropTypes.bool,
  storeId: PropTypes.string
};

PriceMessage.defaultProps = {
  loading: false,
  storeId: null,
  listId: undefined
};

export default PriceMessage;
